'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import StockCountContent from './components/StockCountContent';

export default function StockCountPage() {
  return (
    <AppLayout>
      <StockCountContent />
    </AppLayout>
  );
}
